
import { defineComponent, ref, shallowRef, computed, watch } from "vue";
import { LocationAPI } from "@/services/api/Location.service";
import { ITabConfig } from "@/interfaces/iTabConfig";
import { locationRowTabs } from "../dataTableOptions";
import VZTabs from "@/components/content/VZTabs.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "location-detail",
  components: { VZTabs },
  setup(_, { emit }) {
    const loading = ref(false);
    const route = useRoute();
    const tabs = shallowRef<ITabConfig[]>(locationRowTabs());
    const tableRowClick = (item) => {
      tabs.value = tabs.value.map((tab) => {
        return { ...tab, props: { ...tab.props, data: item } };
      });
    };
    const eventWebId = computed(() => {
      return (route.params.id as string) || ("0" as string);
    });
    const queryUpdate = async (webId: string) => {
      try {
        loading.value = true;
        const data = await LocationAPI.getInstance().getLocation(+webId);
        emit("updateRoute", {
          title: data.name,
          icon: "bi bi-geo-alt",
        });
        tableRowClick(data);
      } finally {
        loading.value = false;
      }
    };

    watch(
      eventWebId,
      async (val) => {
        if (val && val !== "0") {
          queryUpdate(val);
        }
      },
      { immediate: true }
    );
    return {
      tabs,
      loading,
      tableRowClick,
    };
  },
});
